module.exports = __webpack_public_path__ + "media/images/login/ic_login_textbox-1b7bc40f316110e471466533e1c5444a.svg";